import React from 'react'
import styled from 'styled-components'

const Description = styled.div`
    width: 100%;
    font-size: 15px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary};
    margin-bottom: 10px;
    line-height: 1.6;

    @media only screen and (max-width: 768px) {
        font-size: 13px;
    }
`

const Span = styled.span`
    overflow: hidden;
    display: -webkit-box;
    max-width: 100%;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
`

const Card = styled.div`
    width: 100%;
    border-radius: 14px;
    padding: 16px 20px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 12px;
    transition: all 0.3s ease;
    border: 1px solid ${({ theme }) => theme.card_border};
    background: ${({ theme }) => theme.card};
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 20px ${({ theme }) => theme.shadow};

    &:hover {
        transform: translateY(-4px);
        border-color: ${({ theme }) => theme.primary}44;
        box-shadow: 0 8px 32px ${({ theme }) => theme.shadow_primary};
    }

    &:hover ${Span} {
        overflow: visible;
        -webkit-line-clamp: unset;
    }

    @media only screen and (max-width: 768px) {
        padding: 12px 14px;
        gap: 8px;
        width: 300px;
    }
`

const Top = styled.div`
    width: 100%;
    display: flex;
    gap: 12px;
`

const Image = styled.img`
    height: 50px;
    width: 50px;
    object-fit: cover;
    border-radius: 10px;
    margin-top: 4px;
    background: ${({ theme }) => theme.card_solid};

    @media only screen and (max-width: 768px) {
        height: 40px;
        width: 40px;
    }
`

const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2px;
`

const Name = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.text_primary};
    @media only screen and (max-width: 768px) {
        font-size: 14px;
    }
`

const Degree = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.text_secondary};
    @media only screen and (max-width: 768px) {
        font-size: 12px;
    }
`

const Date = styled.div`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_tertiary};
    @media only screen and (max-width: 768px) {
        font-size: 10px;
    }
`

const Grade = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.text_secondary};
    @media only screen and (max-width: 768px) {
        font-size: 12px;
    }
`

const EducationCard = ({ education }) => {
    return (
        <Card>
            <Top>
                <Image src={education.img} alt={education.school} />
                <Body>
                    <Name>{education.school}</Name>
                    <Degree>{education.degree}</Degree>
                    <Date>{education.date}</Date>
                </Body>
            </Top>
            <Grade><b>Grade: </b>{education.grade}</Grade>
            <Description>
                <Span>{education.desc}</Span>
            </Description>
        </Card>
    )
}

export default EducationCard
